import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/layouts/default.vue").then(m => m.default || m))
}